import { createTheme } from "@mui/material";

export function getTheme(mode: "light" | "dark") {
  return createTheme({
    palette: {
      mode,
      background: {
        default: mode === "dark" ? "#0f0f0f" : "#fafafa",
        paper: mode === "dark" ? "#1a1a1a" : "#fff",
      },
      primary: {
        main: "#ff6b35",
        light: "#ff8a65",
        dark: "#e55722",
      },
      secondary: {
        main: "#4fc3f7",
        light: "#81d4fa",
      },
      text: {
        primary: mode === "dark" ? "#ffffff" : "#222",
        secondary: mode === "dark" ? "#a0a0a0" : "#666",
      },
      divider: mode === "dark" ? "#333333" : "#e0e0e0",
      success: {
        main: "#4caf50",
        light: "#66bb6a",
      },
    },
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            "& .MuiOutlinedInput-root": {
              backgroundColor: mode === "dark" ? "#2a2a2a" : "#fff",
              "& fieldset": {
                borderColor: mode === "dark" ? "#404040" : "#ccc",
              },
              "&:hover fieldset": {
                borderColor: "#ff6b35",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#ff6b35",
                borderWidth: "2px",
              },
            },
            "& .MuiInputLabel-root": {
              color: mode === "dark" ? "#a0a0a0" : "#888",
            },
            "& .MuiInputLabel-root.Mui-focused": {
              color: "#ff6b35",
            },
            "& .MuiOutlinedInput-input": {
              color: mode === "dark" ? "#ffffff" : "#222",
            },
          },
        },
      },
    },
  });
}
